"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CROSSHAIR_Y = exports.CROSSHAIR_X = exports.NAME_CLASS = exports.VALUE_CLASS = exports.MARKER_CLASS = exports.LIST_ITEM_CLASS = exports.LIST_CLASS = exports.TITLE_CLASS = exports.CONTAINER_CLASS = void 0;
exports.CONTAINER_CLASS = 'g2-tooltip';
exports.TITLE_CLASS = 'g2-tooltip-title';
exports.LIST_CLASS = 'g2-tooltip-list';
exports.LIST_ITEM_CLASS = 'g2-tooltip-list-item';
exports.MARKER_CLASS = 'g2-tooltip-marker';
exports.VALUE_CLASS = 'g2-tooltip-value';
exports.NAME_CLASS = 'g2-tooltip-name';
exports.CROSSHAIR_X = 'g2-tooltip-crosshair-x';
exports.CROSSHAIR_Y = 'g2-tooltip-crosshair-y';
//# sourceMappingURL=css-const.js.map